import { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";
// import StatsCards from "./StatsCards";

// import ProductCard from "../pages/Products/ProductCard";

import ProductForm from "../pages/Products/ProductForm";
import ConfirmDialog from "../pages/Products/ConfirmDialog";
// import { Button, Box } from "@mui/material";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  // IconButton,
  // Menu,
  // MenuItem,
  // Avatar,
} from "@mui/material";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
import ProductRow from "./ProductRow";
import ProductDetail from "../pages/Products/ProductDetail";

const API = process.env.REACT_APP_BACKEND_URL;

const DashboardPage = () => {
  const [products, setProducts] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const fetchProducts = async () => {
    const res = await axios.get(`${API}/api/products`);
    setProducts(res.data);
  };

  useEffect(() => {
    fetchProducts();
  }, []);

const handleSubmit = async (productformData) => {
  console.log(productformData, 'productformData')
  const data = new FormData();
    
  data.append("name", productformData.name);
  data.append("description", productformData.description);
  data.append("price", productformData.price);
  data.append("originalPrice", productformData.originalPrice);
  data.append("category", productformData.category);
  data.append("subCategory", productformData.subCategory);
  data.append("gender", productformData.gender);
  data.append("color", JSON.stringify(productformData.color));
  data.append("sizes", JSON.stringify(productformData.sizes));
  data.append("brand", productformData.brand);
  data.append("discount", productformData.discount);
  data.append("inStock", productformData.inStock);
  data.append("productDetails", JSON.stringify(productformData.productDetails));

  // MAIN IMAGE
  if (productformData.mainImage instanceof File) {
    data.append("mainImage", productformData.mainImage);
  }

  // OTHER IMAGES
  productformData.otherImages.forEach(file => {
    if (file instanceof File) {
      data.append("otherImages", file);
    }
  });

  try {

    if (editData) {
      await axios.put(`${API}/api/products/${editData._id}`, data);
    } else {
      await axios.post(`${API}/api/products`, data);
    }

    fetchProducts();
    setOpenForm(false);
    setEditData(null);

  } catch (err) {
    console.log(err);
  }
};


  const handleDelete = async () => {
    await axios.delete(`${API}/api/products/${deleteId}`);
    fetchProducts();
    setDeleteId(null);
  };

 return (
  <DashboardLayout>
    {/* Header */}
    <Box className="flex justify-between items-center mb-6">
      <Typography variant="h5" fontWeight="bold">
        Products
      </Typography>

      <Box className="flex gap-3">
        <Button variant="outlined">Filter</Button>
        <Button variant="outlined">See All</Button>
        <Button
          variant="contained"
          onClick={() => setOpenForm(true)}
        >
          Add Product
        </Button>
      </Box>
    </Box>

    {/* Product Table Card */}
    <Card className="rounded-2xl shadow-md">
      <CardContent>

        {/* Table Header */}
        <Box className="grid grid-cols-6 font-semibold text-gray-600 border-b pb-3 mb-3">
          <Typography>Product</Typography>
          <Typography>Category</Typography>
          <Typography>Price</Typography>
          <Typography>Sizes</Typography>
          <Typography>Stock</Typography>
          <Typography align="right">Action</Typography>
        </Box>

        {/* Table Rows */}
        {products.map((product) => (
          <ProductRow
            key={product._id}
            product={product}
            onView={(p) => setViewProduct(p)}
            onEdit={(p) => {
              setEditData(p);
              setOpenForm(true);
            }}
            onDelete={(id) => setDeleteId(id)}
          />
        ))}
      </CardContent>
    </Card>

    {/* Existing Dialogs */}
    <ProductForm
      open={openForm}
      handleClose={() => {
        setOpenForm(false);
        setEditData(null);
      }}
      handleSubmit={handleSubmit}
      editData={editData}
    />
<ProductDetail
  open={Boolean(viewProduct)}
  handleClose={() => setViewProduct(null)}
  product={viewProduct}
/>
    <ConfirmDialog
      open={Boolean(deleteId)}
      handleClose={() => setDeleteId(null)}
      handleConfirm={handleDelete}
    />
  </DashboardLayout>
);

};
export default DashboardPage;
